import { render, staticRenderFns } from "./POI.vue?vue&type=template&id=56e34b70"
import script from "./POI.js?vue&type=script&lang=js&external"
export * from "./POI.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports